import {Column, HeaderProps} from 'react-table'
import {ICategoryList} from '../core/_model'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import {KTIcon} from '../../../../_metronic/helpers'
import {formatDateAsDayAndTime} from '../../../utils/helperFunction/_helper'

const categoryListColumn = (
  handleSelect: (selectType: string, id: number) => void
): ReadonlyArray<Column<ICategoryList>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ICategoryList>>) => (
      <CustomHeader tableProps={props} title='category name' className='min-w-100px' />
    ),
    id: 'category_name',
    accessor: 'category_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ICategoryList>>) => (
      <CustomHeader tableProps={props} title='created' className='min-w-100px' />
    ),
    id: 'created_at',
    accessor: 'created_at',
    Cell: ({...props}) => (
      <p className='m-0'>{formatDateAsDayAndTime(props.data[props.row.index].created_at)}</p>
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ICategoryList>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <div className='text-end'>
        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_1'
          onClick={() => handleSelect('edit', props.data[props.row.index].id)}
        >
          <KTIcon iconName='pencil' className='fs-3' />
        </button>

        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mb-1 btn-color-danger'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_2'
          onClick={() => handleSelect('delete', props.data[props.row.index].id)}
        >
          <KTIcon iconName='trash' className='fs-3' />
        </button>
      </div>
    ),
  },
]

export default categoryListColumn
